import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessReservationsDataService, FitnessReservationsColumnsService } from '../../../services';
import { FitnessReservation, FitnessReservationsResult } from '../../../interfaces';

@Component({
  selector: 'app-fitness-reservation-form',
  templateUrl: './fitness-reservation-form.component.html',
  styleUrls: ['./fitness-reservation-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessReservationFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public fitnessReservation: FitnessReservation = {};
  public fitnessReservationForm: FormGroup = new FormGroup({});
  public fitnessReservations: FitnessReservation[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessReservationsDataService: FitnessReservationsDataService,
    public fitnessReservationsColumnsService: FitnessReservationsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'FitnessReservationFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Reservation - Edit');
        this.getFitnessReservation(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessReservation !== 'undefined') {
      this.fitnessReservation = this.dynamicDialogConfig.data.fitnessReservation;
    }
    if (typeof this.fitnessReservation.id === 'undefined' || this.fitnessReservation.id === null) {
      this.fitnessReservation.id = null;
      this.fitnessReservation.attendingTime = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.fitnessReservation.isConfirmed = false;
    }
    this.getFitnessReservations();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'FitnessReservationFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'FitnessReservationFormComponent');
  }

  getFitnessReservation(id: number): void {
    this.isLoading = true;
    this.fitnessReservationsDataService.getFitnessReservation(id).subscribe((response: FitnessReservation|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessReservation = response;
        this.prepareFrom();
      }
    });
  }

  getFitnessReservations(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessReservations !== 'undefined' && this.dynamicDialogConfig.data.fitnessReservations.length > 0) {
      this.fitnessReservations = this.dynamicDialogConfig.data.fitnessReservations;
      return;
    }
    this.fitnessReservationsDataService.getFitnessReservations(this.parameters).subscribe((response: FitnessReservationsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessReservations = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.fitnessReservation.attendingTime = moment(this.fitnessReservation.attendingTime).toDate();
    this.fitnessReservationForm = new FormGroup({
      id: new FormControl(this.fitnessReservation.id, []),
      attendingTime: new FormControl(this.fitnessReservation.attendingTime, []),
      attendingDuration: new FormControl(this.fitnessReservation.attendingDuration, []),
      fitnessSession: new FormControl((typeof this.fitnessReservation.fitnessSession === 'number') ? this.fitnessReservation.fitnessSession : this.fitnessReservation.fitnessSession?.id, [Validators.required, ]),
      member: new FormControl((typeof this.fitnessReservation.member === 'number') ? this.fitnessReservation.member : this.fitnessReservation.member?.id, [Validators.required, ]),
      isConfirmed: new FormControl(this.fitnessReservation.isConfirmed, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/fitness-reservations']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.fitnessReservationForm.controls).forEach((field: any) => {
        const control = this.fitnessReservationForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.fitnessReservationForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.fitnessReservation = this.fitnessReservationForm.value;
    this.disableSubmit = true;
    console.log('fitnessReservation', this.fitnessReservation);
    if (typeof this.fitnessReservation.id !== 'undefined' && this.fitnessReservation.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.fitnessReservationsDataService.updateFitnessReservation(this.fitnessReservation).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSRESERVATIONUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSRESERVATIONNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.fitnessReservationsDataService.addFitnessReservation(this.fitnessReservation).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSRESERVATIONCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSRESERVATIONNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-fitness-reservation-form',
  templateUrl: './fitness-reservation-form.component.html',
  styleUrls: ['./fitness-reservation-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessReservationFormComponent extends FitnessReservationFormComponent {
}

